import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Button, Column, Row, Text } from 'Components/UI'
import { ContactAltPageData } from 'Data/types'

import { LocationGlyph, MailGlyph, PhoneGlyph } from 'Assets/Svg/Icons'

import {
  ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_HREF,
} from 'Constants/Contact'
import { GOOGLE_MAPS_QUERY_TEMPLATE } from 'Constants/ExternalLinks'

import { useAppContext } from 'Services/AppContext'

import { ContactLink } from './styles'

type Props = PaddingProps & {
  data?: ContactAltPageData['contactAltPage']
}

// Copy comes from the migrated contactAltPage record (Data/Pages/contactAlt).
// The support widget is the primary CTA; the mailto, tel and address links
// keep the conversion path crawlable without JS.
function ContactHeroSection({ data, ...rest }: Props) {
  const { openSupportWidget } = useAppContext()

  return (
    <SectionWrapper {...rest}>
      <Column alignStart fullWidth gap={5}>
        <Text as="h1" medium title title52>
          {data?.title}
        </Text>

        <Text body body16 maxWidth="640px" semiLight>
          {data?.subtitle}
        </Text>

        <Row mt={5}>
          <Button height="48px" type="button" onClick={openSupportWidget}>
            <Text as="span" body16 medium>
              Let&apos;s Chat
            </Text>
          </Button>
        </Row>

        <Column gap={4} mt={9}>
          <ContactLink href={`mailto:${CONTACT_EMAIL}`}>
            {MailGlyph()}

            <Text as="span" body16 medium>
              {CONTACT_EMAIL}
            </Text>
          </ContactLink>

          <ContactLink href={`tel:${CONTACT_PHONE_HREF}`}>
            {PhoneGlyph()}

            <Text as="span" body16 medium>
              {CONTACT_PHONE}
            </Text>
          </ContactLink>

          <ContactLink
            href={`${GOOGLE_MAPS_QUERY_TEMPLATE}${ADDRESS.AU.COORDS}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {LocationGlyph()}

            <Text as="span" body16 medium>
              {ADDRESS.AU.TEXT}
            </Text>
          </ContactLink>
        </Column>
      </Column>
    </SectionWrapper>
  )
}

export default ContactHeroSection
